/**
 * MSE clássico de fMP4. Safari/Chrome no iOS (WebKit) não suportam
 * `video/mp4` via MediaSource — `isTypeSupported` falha ou o construtor não existe.
 */
export function mseStreamingSupported(
  mimeCodec: string | null | undefined,
  mediaSourceCtor: { isTypeSupported?(codec: string): boolean } | null | undefined =
    typeof MediaSource !== 'undefined' ? MediaSource : undefined,
): boolean {
  if (!mimeCodec || !mediaSourceCtor || typeof mediaSourceCtor.isTypeSupported !== 'function') {
    return false;
  }
  try {
    return mediaSourceCtor.isTypeSupported(mimeCodec);
  } catch {
    return false;
  }
}
